import { param } from "jquery";

/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-29 11:03:21
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-12-18 14:19:49
 */
const TYPE = {
  1: "首页banner",
  2: "优惠券弹窗",
  3: "首页视频",
  4: "招募弹窗",
  5: "金刚区",
};
const STATUS = {
  0: "上架",
  1: "下架",
};

// 检测文件是否为视频
const isVideoFile = (filePath) => {
  if (!filePath) return false;
  const videoExtensions = ['.mp4', '.MP4', '.mov', '.MOV'];
  return videoExtensions.some(ext => filePath.toLowerCase().endsWith(ext.toLowerCase()));
};

export default (Vue) => {
  return [
    {
      title: "模块名称",
      key: "type",
      minWidth: 120,
      align: "center",
      render: (h, { row }) => {
        const text = TYPE[String(row.type)];
        return h("span", {}, text);
      },
    },
    {
      title: "banner图片",
      key: "url",
      align: "center",
      minWidth: 80,
      render: (h, { row }) => {
        const isVideo = isVideoFile(row.cover);
        return h(isVideo ? "video" : "img", {
          style: {
            width: "100px",
            height: "50px",
            cursor: "pointer",
          },
          attrs: {
            src: Vue.host + row.cover,
          },
          on: {
            click: () => {
              if (isVideo) {
                // 打开视频播放弹窗
                Vue.videoModalUrl = Vue.host + row.cover;
                Vue.showVideoModal = true;
              }
            },
          },
        });
      },
    },
    {
      title: "跳转链接",
      key: "url",
      align: "center",
      minWidth: 80,
      render: (h, { row }) => {
        const path = row.url || "-";
        return h(
          "span",
          {
            style: {
              cursor: "pointer",
            },
          },
          path
        );
      },
    },
    {
      title: "排序",
      key: "sort",
      align: "center",
      minWidth: 80,
      render: (h, { row }) => {
        const sort = row.sort || "-";
        return h("span", {}, sort);
      },
    },
    {
      title: "操作",
      key: "action",
      fixed: "right",
      align: "center",
      width: 200,
      render: (h, { row }) => {
        const btnText = STATUS[String(row.isPublic)];
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  Vue.$confirm(`确认${btnText}此banner?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }).then(async () => {
                    await Vue.$post("/banner/updatePublic", {
                      bannerId: row.bannerId,
                      isPublic: row.isPublic == 0 ? 1 : 0,
                    });
                    Vue.$Notice.success({ title: "操作成功" });
                    Vue.getBannerList();
                  });
                },
              },
            },
            btnText
          ),
          h(
            "Button",
            {
              props: {
                type: "text",
                size: "small",
              },
              style: {
                color: "#3091FF",
              },
              on: {
                click: () => {
                  Vue.addInfo = JSON.parse(JSON.stringify(row));
                  Vue.editFlag = true;
                  Vue.showDispatch = true;
                },
              },
            },
            "编辑"
          ),
          // h(
          //   "Button",
          //   {
          //     props: {
          //       type: "text",
          //       size: "small",
          //     },
          //     style: {
          //       color: "#3091FF",
          //     },
          //     on: {
          //       click: () => {
          //         Vue.$confirm("确认删除?", "提示", {
          //           confirmButtonText: "确定",
          //           cancelButtonText: "取消",
          //           type: "warning",
          //         })
          //           .then(async () => {
          //             await Vue.$post("/banner/delete", {
          //               bannerIds: row.bannerId,
          //             });
          //             Vue.$Notice.success({ title: "删除成功" });
          //             Vue.getBannerList();
          //           })
          //           .catch(() => {
          //             this.$message({
          //               type: "info",
          //               message: "已取消删除",
          //             });
          //           });
          //       },
          //     },
          //   },
          //   "删除"
          // ),
        ]);
      },
    },
  ];
};
